export default __webpack_public_path__ + "static/media/fitToken.d32f09ee.png";